import { api as baseApi } from '../api.js';

// Step02 now forms and persists Product Truth before the short keyword check.
// Keep the browser alive through the Agent's bounded call + optional evidence
// repair so a safe server fallback is returned instead of a client abort.
const PRECHECK_CLIENT_TIMEOUT_MS = 150_000;

export async function preCheckKeywords(sellingPoints, selectedKeywords, jobId = "", context = {}) {
  const controller = new AbortController();
  const timeoutId = globalThis.setTimeout(() => controller.abort(), PRECHECK_CLIENT_TIMEOUT_MS);
  try {
    return await baseApi.preCheckKeywords(sellingPoints, selectedKeywords, jobId, context, {
      signal: controller.signal,
    });
  } catch (error) {
    if (controller.signal.aborted) {
      throw new Error('关键词检测超时，请重试。');
    }
    throw error;
  } finally {
    globalThis.clearTimeout(timeoutId);
  }
}

export function marketDataKeywords(body) {
  return baseApi.marketDataKeywords(body);
}

export function mcpKeywords(body) {
  return baseApi.mcpKeywords(body);
}

export function keywordCoverageAnalyze(body) {
  return baseApi.keywordCoverageAnalyze(body);
}

export function listingOptimizerDiagnose(body) {
  return baseApi.listingOptimizerDiagnose(body);
}

export function translateSearchTerms(body) {
  return baseApi.translateSearchTerms(body);
}
